import { useAuthService } from '../../application/services/authService'

const useAuth = () => useAuthService()

export default useAuth
